/**
 * Do not change this manually.
 *
 *
 * version number taken from package.json
 * changed by pre-build script.
 * @type {string}
 */
export const version = '5.180.6';
